// @vendor
import React from 'react';
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
const cryptoJS = require('crypto-js');
// @actions
const identityValidationActions = require('actions/identityValidationActions');
const mapActions = require('actions/mapActions');
const preLoaderActions = require('actions/preLoaderActions');
const formActions = require('react-redux-form').actions;
// @components
const { SearchBoxMap } = require('./searchbox/searchboxMap');
const { MarkersMap } = require('./markers/markersMap');
// @utilities
const { recordEvent, RELIABLE, PAGE_PRODUCT, errorTag } = require('utilities/uTagging');
const {
    handleMyPositionIcon,
    handleGeocoder,
    handleCenterMapHelper,
    handleMarkersHelper,
} = require('./helper/mapHelper');
// @constants
const { PATH_IDENTITY, PATH_IDENTITY_POST_OFFICE_MAP } = require('constants/uTagConstants/paths');
const { ERROR_CASO_EN_OFICINA } = require('constants/analyticsErrors');
import { goToErrorsView } from 'actions/errorViewNavigation';

class Map extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            center: {},
            centerChanged: false,
            myPosition: {},
            geolocation: false,
            markers: [],
        };
    }

    componentDidMount() {
        const { userProfile } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const address = `${
            userProfile.nameOfRoad + (userProfile.addressNumber ? ` ${userProfile.addressNumber}` : '')
        }, ${userProfile.postalCode}, ${userProfile.town}`;
        handleGeocoder(address, (latitude, longitude) => {
            this.handleCenterMap({ lat: latitude, lng: longitude }, true);
            this.getPostOfficesByLatLong(latitude, longitude);
        });
        recordEvent(
            PATH_IDENTITY_POST_OFFICE_MAP,
            PAGE_PRODUCT,
            'identidad',
            'correo-mapa',
            userProfile.recordId,
            userProfile.userId,
            '',
            userProfile.investmentType,
            docNumberEncrypted
        );
    }

    getPostOfficesByLatLong(lat, long) {
        const { mapActions } = this.props;
        mapActions.clearBranches();
        mapActions.getPostOfficeByLatLong(lat, long, () => {
            this.handleMarkers();
        });
        this.setState({
            markers: [],
        });
    }

    handleCenterMap = (mapCenter, myInitialPosition = false) => {
        const output = handleCenterMapHelper(mapCenter, myInitialPosition);
        this.setState(output);
    };

    handleMarkers = () => {
        const markers = handleMarkersHelper(this.props, this.state);
        this.setState({
            markers,
        });
    };

    handleDragEnd = center => {
        const lat = center.lat();
        const lng = center.lng();
        this.getPostOfficesByLatLong(lat, lng);
    };

    onPlacesChanged = center => {
        const lat = center.lat;
        const lng = center.lng;
        this.getPostOfficesByLatLong(lat, lng);

        this.setState({
            center,
            myPosition: center,
        });
    };

    onEventMarker = (current, show) => {
        const marker = { ...current };
        const { markers } = this.state;
        marker.openInfoWindow = show;
        markers[marker.key] = marker;
        this.setState({
            markers,
        });
    };

    handleAction(marker) {
        const { userProfile, identityValidationActions, preLoaderActions, goToErrorsView } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';

        preLoaderActions.showPreLoader();
        identityValidationActions.clientIdentificationCorreos(marker, userProfile.accessToken, (identified, error) => {
            preLoaderActions.hidePreLoader();
            if (!identified) {
                errorTag(error.body, PATH_IDENTITY_POST_OFFICE_MAP, ERROR_CASO_EN_OFICINA, error.statusCode);
                goToErrorsView({ errorCode: error.statusCode, errorMessage: ERROR_CASO_EN_OFICINA });
            }
        });

        recordEvent(
            PATH_IDENTITY,
            PAGE_PRODUCT,
            'validacion por correo',
            'validacion por correo correcto',
            userProfile.recordId,
            userProfile.userId,
            RELIABLE['postOffice'],
            userProfile.investmentType,
            docNumberEncrypted
        );
    }

    render() {
        const { markers } = this.state;

        return (
            <GoogleMap
                ref={map => (this._map = map)}
                defaultZoom={14}
                options={{
                    streetViewControl: false,
                    fullscreenControl: false,
                    mapTypeControl: false,
                }}
                defaultCenter={{ lat: -34.397, lng: 150.644 }}
                center={this.state.center}
                onDragEnd={() => {
                    this.handleDragEnd(this._map.getCenter());
                }}
            >
                <SearchBoxMap onPlacesChanged={center => this.onPlacesChanged(center)} />
                <Marker
                    position={this.state.myPosition}
                    key="myPosition"
                    icon={handleMyPositionIcon(this.state.geolocation)}
                />
                <MarkersMap
                    markers={markers}
                    onEventMarker={(marker, show) => this.onEventMarker(marker, show)}
                    handleAction={marker => this.handleAction(marker)}
                />
            </GoogleMap>
        );
    }
}

const SimpleMapConnected = connect(
    state => ({
        userProfile: state.userProfile,
        map: state.map,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        identityValidationActions: bindActionCreators(identityValidationActions, dispatch),
        mapActions: bindActionCreators(mapActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
    })
)(Map);

export default withScriptjs(withGoogleMap(SimpleMapConnected));
